/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type {RecogniserResponse} from "./RecogniserResponse";
import type {TaxAccountantDto} from "./TaxAccountantDto";
import type {TaxClientDto} from "./TaxClientDto";
import type {TaxPreAccountingDto} from "./TaxPreAccountingDto";
import {CoreCompany, CoreCurrency, CorePerson, CoreUser} from "@mm-products/java-multima-framework";
import {TaxAbraDocumentTypeDto} from "./TaxAbraDocumentTypeDto";
import {TaxCentreDto} from "./TaxCentreDto";
import {TaxActivityDto} from "./TaxActivityDto";
import {TaxContractDto} from "./TaxContractDto";

export type TaxDocumentDto = {
    readonly _permissions?: Array<string>;
    amountTotal?: number;
    amountVatBasic?: number;
    amountVatReduced?: number;
    amountVatReduced2?: number;
    amountVatUnknown?: number;
    baseTotal?: number;
    baseVat0?: number;
    baseVatNone?: number;
    baseVatUnknown?: number;
    baseVatBasic?: number;
    baseVatReduced?: number;
    baseVatReduced2?: number;
    classification?: TaxDocumentDto.classification;
    correctionRequired?: boolean;
    corrector?: CoreUser;
    created?: string;
    creator?: string;
    creatorId?: string;
    currency?: CoreCurrency;
    customerCompanyIdNumber?: string;
    description?: string;
    dueDate?: string;
    duplicated?: boolean;
    extractCorrectedErrorCount?: number;
    extractCorrectedRate?: number;
    extractRate?: number;
    id?: string;
    importError?: number;
    importNote?: string;
    isdoc?: boolean;
    issueDate?: string;
    kind?: TaxDocumentDto.kind;
    lastCorrectionAt?: string;
    miningStatus?: TaxDocumentDto.miningStatus;
    modified?: string;
    modifier?: string;
    modifierId?: string;
    originalCreator?: string;
    originalCreatorId?: string;
    originalModifier?: string;
    originalModifierId?: string;
    owner?: TaxClientDto;
    ownerNote?: string;
    payableAmount?: number;
    paymentMeans?: TaxDocumentDto.paymentMeans;
    pdf?: boolean;
    preAccounting?: TaxPreAccountingDto;
    processor?: TaxAccountantDto;
    processorNote?: string;
    recogniserResponse?: RecogniserResponse;
    regNumber?: string;
    source?: TaxDocumentDto.source;
    status?: TaxDocumentDto.status;
    supplier?: CoreCompany;
    supplierCompanyIdNumber?: string;
    supplierPerson?: CorePerson;
    supplierTaxIdNumber?: string;
    taxableSupplyDate?: string;
    timeStamped?: boolean;
    type?: TaxDocumentDto.type;
    vatApplicable?: boolean;
    vatApplicationDate?: string;
    vatBasic?: number;
    vatReduced?: number;
    vatReduced2?: number;
    vatUnknown?: number;
    vatTotal?: number;
    abraDocumentType?: TaxAbraDocumentTypeDto;
    centre?: TaxCentreDto;
    recogniserSupplierName?: string;
    recogniserSupplierAddress?: string;
    reverseCharge?: boolean;
    variableSymbol?: string;
    accountNumber?: string;
    bankCode?: string;
    iban?: string;
    bic?: string;
    approvalType: TaxDocumentDto.approvalType;
    approvedAt: string;
    approver: CoreUser;
    approvalComment: string;
    approvalStatus: TaxDocumentDto.approvalStatus;
    contract: TaxContractDto;
    activity: TaxActivityDto;
};

export namespace TaxDocumentDto {
    export enum classification {
        OTHER_OBLIGATIONS = "OTHER_OBLIGATIONS",
        PRO_FORMA_INVOICE = "PRO_FORMA_INVOICE",
        INVOICE_IN_ADVANCE = "INVOICE_IN_ADVANCE",
        EXPENSE_RECEIPT = "EXPENSE_RECEIPT",
    }

    export enum approvalType {
        BEFORE_MINING = "BEFORE_MINING",
        AFTER_MINING = "AFTER_MINING",
        BEFORE_CONFIRM = "BEFORE_CONFIRM",
    }

    export enum approvalStatus {
        APPROVED = "APPROVED",
        REJECTED = "REJECTED",
    }

    export enum kind {
        INCOMING = "INCOMING",
        OUTCOMING = "OUTCOMING",
        OTHER = "OTHER",
    }

    export enum miningStatus {
        NEW = "NEW",
        TO_EXTRACT = "TO_EXTRACT",
        NOT_TO_EXTRACT = "NOT_TO_EXTRACT",
        EXTRACTING = "EXTRACTING",
        EXTRACTED = "EXTRACTED",
        NOT_ENOUGH_CREDIT = "NOT_ENOUGH_CREDIT",
        UNPROCESSABLE = "UNPROCESSABLE",
        ERROR = "ERROR",
        ERROR_FINAL = "ERROR_FINAL",
    }

    export enum paymentMeans {
        CASH_PAYMENT = "CASH_PAYMENT",
        CHEQUE_PAYMENT = "CHEQUE_PAYMENT",
        CREDIT_TRANSFER = "CREDIT_TRANSFER",
        MONEY_TRANSFER_TO_ACCOUNT = "MONEY_TRANSFER_TO_ACCOUNT",
        CARD_PAYMENT = "CARD_PAYMENT",
        DIRECT_DEBIT = "DIRECT_DEBIT",
        PAYMENT_BY_POSTGIRO = "PAYMENT_BY_POSTGIRO",
        COMPOSITION_BETWEEN_PARTNERS = "COMPOSITION_BETWEEN_PARTNERS",
        OTHER = "OTHER",
    }

    export enum source {
        MOBILE_SCAN = "MOBILE_SCAN",
        MOBILE_FILE = "MOBILE_FILE",
        WEB_FILE = "WEB_FILE",
        EMAIL = "EMAIL",
    }

    export enum exportType {
        ISDOC = "ISDOC",
        ARCHIVE = "ARCHIVE",
        GENERAL_DATA = "GENERAL_DATA",
        TAX_DOCUMENT_DATA = "TAX_DOCUMENT_DATA",
    }

    export enum exportFormat {
        ZIP = "ZIP",
        EXCEL = "EXCEL",
        CSV = "CSV",
    }

    export enum status {
        INSERTED = "INSERTED",
        EXTRACTED = "EXTRACTED",
        CONFIRMED = "CONFIRMED",
        IN_ACCOUNTING = "IN_ACCOUNTING",
        ACCOUNTING_ERROR = "ACCOUNTING_ERROR",
        AWAITING_CORRECTION = "AWAITING_CORRECTION",
        UNDER_CORRECTION = "UNDER_CORRECTION",
        FOR_APPROVAL = "FOR_APPROVAL",
        DO_NOT_PROCESS = "DO_NOT_PROCESS",
    }

    export enum type {
        INVOICE = "INVOICE",
        RECEIPT = "RECEIPT",
        CONFIRMATION = "CONFIRMATION",
        OTHER = "OTHER",
    }
}
